import signalr from '@/service/signalr';
import uuid from 'uuid/v1';
let vaild  = ["pong", "status"]
let resolveMapWS = {};
const rvWS = {
  Cmd(cmd = undefined, agent_id="", body) {
    return new Promise((resolve, reject) => {
      let UUID = "";
      if(agent_id == "undefined") { resolve("") }
      else if(cmd.indexOf("_") > -1) { UUID  = `${rvWS.user_id}.${cmd.split("_")[0]}` }
      else if(cmd === "ping") { UUID  = `${rvWS.user_id}.pong` }
      else if(cmd === "start") { UUID  = `result` }
      else { UUID  = `${rvWS.user_id}.${cmd}` }
      resolveMapWS[UUID] = { resolve, reject };
      // location.hostname == "localhost" ? console.log("request", "cmd", `${cmd}.${agent_id}` ) : '';
      return signalr.socket().invoke('wsfinder', { app_id: 'wsfinder', cmd : `${cmd}.${agent_id}`,  body : body });
    });
  },
  user_id : "ws."+uuid()
}

signalr.subscribe('wsfinder', (response) => {

  if(!response || !response.cmd) { return; }
  try { if(response.cmd != "pong") { response.body = typeof response.body == "string" ? JSON.parse(response.body) : response.body; } }
  catch(e) { console.log("parser error or from data mq version"); return; }
  if(!response || response.body == null) { console.log("result null or error"); return; }
  let cmd = response.cmd === "result" ? "result" : `${rvWS.user_id}.${response.cmd}` || '';
  if(vaild.indexOf(response.cmd) === -1) { console.log("check cmd", cmd); return; }

  if(resolveMapWS[cmd]) {
    response.ch = "ws";
    // location.hostname == "localhost" ? console.log("response ws", "cmd", `${response.cmd}`, response) : '';
    resolveMapWS[cmd].resolve(response);
    delete resolveMapWS[cmd];
  }
});
// export default rvWS;

let resolveMap = {};
const rv = {
  Cmd(type, agent=undefined, cmd=undefined) {
    return new Promise((resolve, reject) => {
      let UUID = "";
      if(type.indexOf("_") > -1) { UUID  = `${rv.user_id}.${type.split("_")[0]}` }
      else if(type === "ping") { UUID  = `${rv.user_id}.pong` }
      else if(type === "start") { UUID  = `result` }
      else { UUID  = `${rv.user_id}.${type}` }
      resolveMap[UUID] = { resolve, reject };
      // location.hostname == "localhost" ? console.log("request mq", "cmd", UUID ) : '';
      return signalr.socket().invoke('wsfinder', {type : type, agent : agent, app_id: 'wsfinder', cmd : cmd });
    });
  },
  user_id : "mq." + uuid()
}

signalr.subscribe('wsfinder', (response) => {
  try {
    return;
    if(!response || response.error) { console.log("result null or error"); return; }
    response = JSON.parse(response) } catch (e) { return; }

    let type = response.pl.type === "result" ? "result" : `${rv.user_id}.${response.pl.type}` || '';
    if("error" === response) { console.error("error"); return; }

    if(response.pl.type != "result" && !resolveMap[type] || !response || vaild.indexOf(response.pl.type) === -1) { console.log("check type", type); return; }
    if(resolveMap[type]) {
      response.ch = "mq";
      // location.hostname == "localhost" ? console.log("reponse mq", "cmd", `${type}`, response) : '';
      resolveMap[type].resolve(response);
      delete resolveMap[type];
    }
});
// export default rv;

export default {
  ws : rvWS,
  mq : rv,
}
